import { useMemo } from 'react';
import { Star } from 'lucide-react';
import { EmptyState, PageHeader, SkeletonList } from '@/components/ui';
import { SignListItem } from '@/components/SignListItem';
import { useCategoryNames, useFavoriteSigns, useSignStates } from '@/hooks/useCatalogQueries';

export function FavoritesPage(): React.ReactElement {
  const favorites = useFavoriteSigns();
  const categoryNames = useCategoryNames();

  const ids = useMemo(() => (favorites ?? []).map((sign) => sign.id), [favorites]);
  const states = useSignStates(ids);

  return (
    <>
      <PageHeader title="Favoritos" subtitle={favorites ? `${favorites.length} sinais` : undefined} />

      {favorites === undefined && <SkeletonList rows={6} />}

      {favorites?.length === 0 && (
        <EmptyState
          icon={<Star size={40} aria-hidden />}
          title="Nenhum favorito ainda"
          description="Marque um sinal como favorito para encontrá-lo rápido aqui, mesmo sem internet."
        />
      )}

      {favorites && favorites.length > 0 && (
        <ul className="flex flex-col pb-4">
          {favorites.map((sign) => (
            <SignListItem
              key={sign.id}
              sign={sign}
              state={states?.get(sign.id)}
              categoryName={categoryNames?.get(sign.categoryId)}
            />
          ))}
        </ul>
      )}
    </>
  );
}
